<template>
  <div ref="buscadorTarifario">
    <v-form @submit.prevent="onSubmit" autocomplete="off">
      <v-container fluid class="px-0">
        <v-layout wrap :[plano]="true">
          <v-flex xs12 sm3>
            <v-select
              :items="destinos.paises"
              :label="loading ? 'Espere...' : 'Países'"
              solo
              item-text="nombre"
              item-value="id"
              :loading="loading"
              @change="buscarDestinos"
              color="red darken-4"
              :error-messages="errors.first('pais')"
              name="pais"
              class="caption"
              :disabled="loading"
              id="inputPaisesTar"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm3>
            <v-autocomplete
              solo
              v-model="form.destino"
              :items="zonas"
              item-value="id"
              item-text="nombre"
              v-validate="'required'"
              name="zona"
              class="caption"
              :error="errors.first('zona')"
              label="Destino"
              :error-messages="errors.first('zona')"
              id="inputCuposDestinos"
              @change="destinoSelected"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>
            <vc-date-picker
              is-expanded
              mode="range"
              :min-date="formConfig.picker.startDate"
              :max-date="formConfig.picker.endDate"
              v-model="startingDates"
              color="red"
              @input="selected"
              :popover="{ visibility: 'click' }"
              :input-props="{
                placeholder: 'Llegada - Salida'
              }"
              :select-attribute="selectDragAttribute"
              :drag-attribute="selectDragAttribute"
              @drag="dragValue = $event"
              id="fechaTar"
            >
              <input
                id="date"
                slot-scope="{ inputProps, inputEvents, isDragging }"
                :class="[
                  `input-as elevation-1 text--grey lighten-2 caption py-2 px-3 ${
                    isDragging ? 'text-gray-400' : 'text-gray-700'
                  }`
                ]"
                v-bind="inputProps"
                v-on="inputEvents"
              />
              <div slot="day-popover" slot-scope="{ format }">
                {{
                  dragValue
                    ? _$diffDias(_$yyyymmdd2Date(dragValue.start), _$yyyymmdd2Date(dragValue.end))
                    : _$diffDias(_$yyyymmdd2Date(startingDates.start), _$yyyymmdd2Date(startingDates.end))
                }}
              </div>
            </vc-date-picker>
            <v-input
              v-model="inputFechas"
              v-validate="'required'"
              name="fechas"
              :error-messages="errors.first('fechas')"
            ></v-input>
          </v-flex>
          <v-flex xs12 sm2>
            <v-btn type="submit" block color="primary" dark large class="mt-0" style="height: 48px;">Buscar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import AxiosHandler from "@/assets/js/class/AxiosHandler.js"
import { mapGetters } from "vuex"
import moment from "moment"
import RqHoteles from "@/assets/js/class/RqHoteles.js"
export default {
  name: "buscadorTarifario",
  props: {
    plano: {
      validator: function(value) {
        return value
      }
    }
  },
  components: {},
  mounted() {
    this.getDestinos()
    //       this.fixEstilosForm();
  },
  beforeCreate() {},
  methods: {
    onSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.doSubmit()
        }
      })
    },
    async getDestinos() {
      this.loading = true
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let handler = new AxiosHandler()
      handler.setPassportHandler(this.$passporthandler)
      const url = `${process.env.VUE_APP_ASBACK}/api/destinos-tarifarios-htls`
      handler.prepare(url, header)
      handler.overlay(false)
      await handler.exe()
      this.destinos = handler.getData().destinos
      this.loading = false
    },
    prepararFecha(string) {
      if (string === null) {
        return null
      }
      let momented = moment(string).toDate()
      return momented
    },
    tomarIn(indate) {
      let _this = this

      let checkin = moment(indate).format("YYYY-MM-DD")
      this.form.checkin = checkin
    },
    tomarOut(outdate) {
      let _this = this
      let checkout = moment(outdate).format("YYYY-MM-DD")
      this.form.checkout = checkout
      if (this.form.checkin != null && this.form.checkout != null) {
        this.inputFechas = `${this.form.checkin}  ${this.form.checkout}`
      }
      this.fixEstilosForm()
    },
    buscarDestinos(pais) {
      this.form.isNacional = pais === 1 ? true : false
      const zonas = this.destinos.zonas.filter(d => d.pais_id === pais)
      this.zonas = zonas

      document.getElementById("inputCuposDestinos").focus()
      document.getElementById("inputCuposDestinos").click()
    },
    async doSubmit() {
      await this.$store.dispatch("app/setBuscando", true)
      let rq = new RqHoteles(this.form)
      const data = rq.armar2EsperaTarifario(
        this.$router.currentRoute.name,
        "Ocurrió un error, será redirigigo al buscador",
        "rsTarifario",
        "rsTarifario"
      )
      this.$router.push({ name: "buscandox", params: { data: data } })
    },
    fixEstilosForm() {
      this.$nextTick(function() {
        let inputs = document.getElementsByClassName("datepicker__input")
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].style.padding = "0"
          inputs[i].style.padding = "10px 0 10px 20px"
          inputs[i].style.fontSize = "12px"
        }
      })
    },
    selected(data) {
      let checkin = moment(data.start).format("YYYY-MM-DD")
      this.form.checkin = checkin
      let checkout = moment(data.end).format("YYYY-MM-DD")
      this.form.checkout = checkout
      if (this.form.checkin != null && this.form.checkout != null) {
        this.inputFechas = `${this.form.checkin}  ${this.form.checkout}`
      }
    },
    destinoSelected() {
      document.getElementById("date").focus()
      document.getElementById("date").click()
    }
  },
  data() {
    return {
      destinos: [],
      zonas: [],
      form: {
        checkin: null,
        checkout: null,
        destino: null,
        isTarifario: true,
        isNacional: false,
        isDc: false
      },
      inputFechas: null,
      loading: false,
      dragValue: null,
      startingDates: null
    }
  },
  computed: {
    ...mapGetters("app", {
      formConfig: "getFormConfigHtl"
    }),
    selectDragAttribute() {
      return {
        popover: {
          visibility: "hover",
          isInteractive: false // Defaults to true when using slot
        }
      }
    }
  }
}
</script>
